
define([
    'jquery',
    'iframeResizer',
    'iframeResizerContent'
],  function ($) {

    function initIframeResize(){

        var $iframeWindow = $('.iframe-window');
        if($iframeWindow.length > 0) {
            var isOldIE = (navigator.userAgent.indexOf("MSIE") !== -1); // Detect IE10 and below
            $iframeWindow.iFrameResize({
                heightCalculationMethod: isOldIE ? 'max' : 'lowestElement',
                minSize:100,
                resizedCallback:function(){
                    $iframeWindow.parent().addClass('loaded');
                }
            });
        }

    }

    initIframeResize();

});
